import { mutatorAction } from 'satcheljs';
import getScenarioStore from '../selectors/getScenarioStore';
import SearchScenarioId from '../store/schema/SearchScenarioId';

const setSearchIncludeDeletedMutator: (includeDeleted: boolean) => void = mutatorAction(
    'setSearchIncludeDeleted',
    (includeDeleted: boolean): void => {
        getScenarioStore(SearchScenarioId.Mail).includeDeletedOverride = includeDeleted;
    }
);

export default setSearchIncludeDeletedMutator;
